module.exports = __webpack_public_path__ + "media/Audio17_c.2d5c7b3a.wav";